import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (error instanceof Error && 'status' in error) {
          const s = (error as { status: number }).status;
          if (s === 401 || s === 403 || s === 404) return false;
        }
        return failureCount < 2;
      },
    },
  },
});
